export function ContactForm() {
    return (
        <form className="space-y-8" onSubmit={(e) => e.preventDefault()}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="space-y-2">
                    <label className="text-xs uppercase tracking-widest text-stone-500">Name</label>
                    <input
                        type="text"
                        className="w-full bg-transparent border-b border-stone-300 py-3 px-1 focus:outline-none focus:border-stone-900 transition-colors font-light"
                        placeholder="Your name"
                    />
                </div>
                <div className="space-y-2">
                    <label className="text-xs uppercase tracking-widest text-stone-500">Email</label>
                    <input
                        type="email"
                        className="w-full bg-transparent border-b border-stone-300 py-3 px-1 focus:outline-none focus:border-stone-900 transition-colors font-light"
                        placeholder="Your email"
                    />
                </div>
            </div>
            <div className="space-y-2">
                <label className="text-xs uppercase tracking-widest text-stone-500">Subject</label>
                <input
                    type="text"
                    className="w-full bg-transparent border-b border-stone-300 py-3 px-1 focus:outline-none focus:border-stone-900 transition-colors font-light"
                    placeholder="How can we help?"
                />
            </div>
            <div className="space-y-2">
                <label className="text-xs uppercase tracking-widest text-stone-500">Message</label>
                <textarea
                    rows={5}
                    className="w-full bg-transparent border-b border-stone-300 py-3 px-1 focus:outline-none focus:border-stone-900 transition-colors font-light resize-none"
                    placeholder="Your message..."
                />
            </div>
            <button className="bg-stone-900 text-white px-12 py-4 text-xs uppercase tracking-widest hover:bg-stone-800 transition-colors">
                Send Message
            </button>
        </form>
    );
}
